<div class="under-maintenance under-maintenance d-flex flex-column text-center pt-4">
    <h1 class="page-title mb-2">Coming Soon!</h1>
    <img src="../../../../assets/images/under-maintenance.png" alt="Under Maintenace Image" />
    <p>This page is currently undergoing a bit of a transformation. We're sprucing things up to bring you an even better experience. We'll be back soon!</p>
    <a href="search" class="btn bg-voilet text-white px-3 py-2 pr-3 pl-3">Home</a>
</div>